import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PrivacyPolicy = () => {
    return (
        <>
            <Header isAlwaysScrolled={true} />
            <main className="pt-24 pb-20 bg-gray-50 dark:bg-black min-h-screen transition-colors duration-300">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl p-8 md:p-12 dark:border dark:border-gray-800 transition-colors duration-300">
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-8" style={{ fontFamily: "'Poppins', sans-serif" }}>
                            Privacy <span className="text-red-600">Policy</span>
                        </h1>

                        <div className="prose prose-lg max-w-none text-gray-600 dark:text-gray-300 space-y-6" style={{ fontFamily: "'Poppins', sans-serif" }}>
                            <p>Last updated: {new Date().toLocaleDateString()}</p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">1. Introduction</h3>
                            <p>
                                Welcome to PizzaToons Foods & Beverages Private Limited ("Company", "we", "our", "us"). We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website (www.pizzatoons.in) and tell you about your privacy rights and how the law protects you.
                            </p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">2. Information We Collect</h3>
                            <p>
                                We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
                                <li><strong>Contact Data:</strong> includes billing address, delivery address, email address and telephone numbers.</li>
                                <li><strong>Technical Data:</strong> includes internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform and other technology on the devices you use to access this website.</li>
                                <li><strong>Usage Data:</strong> includes information about how you use our website, products and services.</li>
                            </ul>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">3. How We Use Your Data</h3>
                            <p>
                                We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>To process and deliver your order.</li>
                                <li>To manage our relationship with you.</li>
                                <li>To enable you to partake in a prize draw, competition or complete a survey.</li>
                                <li>To administer and protect our business and this website.</li>
                                <li>To deliver relevant website content and advertisements to you.</li>
                            </ul>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">4. Data Security</h3>
                            <p>
                                We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.
                            </p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">5. Cookies</h3>
                            <p>
                                You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly.
                            </p>

                            <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8">6. Contact Us</h3>
                            <p>
                                If you have any questions about this privacy policy or our privacy practices, please contact us at:
                            </p>
                            <p className="mt-2">
                                <strong>PizzaToons Foods & Beverages Private Limited</strong><br />
                                Email: info@pizzatoons.in<br />
                                Phone: 07875550787
                            </p>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
